// import { RequireAutorization } from './routerAuth'

export default {
  path: '/empresas',
  component: () => import(/* webpackChunkName: "Companies" */ './Layout.vue'),
  children: [
    {
      path: '',
      name: 'CompanyKanban',
      component: () => import(/* webpackChunkName: "Companies" */'./Kanban.vue'),
      meta: { title: 'Empresas' },
    },
    {
      name: 'CompanyKanbanShow',
      path: ':companyId/kanban',
      component: () => import(/* webpackChunkName: "Companies" */'./Show.vue'),
      meta: { title: 'Exibir Empresa', routeAfterClose: 'CompanyKanban' },
    },
    {
      path: 'lista',
      name: 'CompanyList',
      component: () => import(/* webpackChunkName: "Companies" */'./Index.vue'),
      meta: { title: 'Empresas' },
    },
    {
      path: 'criar',
      name: 'CompanyNew',
      component: () => import(/* webpackChunkName: "Companies" */'./New.vue'),
      meta: { title: 'Criar Empresa' },
    },
    {
      path: ':companyId',
      name: 'CompanyShow',
      component: () => import(/* webpackChunkName: "Companies" */'./Show.vue'),
      meta: { title: 'Exibir Empresa', routeAfterClose: 'CompanyList' },
    },
    {
      path: ':companyId/editar',
      name: 'CompanyEdit',
      component: () => import(/* webpackChunkName: "Companies" */'./Edit.vue'),
      meta: { title: 'Editar Empresa', routeAfterClose: 'CompanyList' },
    },
  ],
  // beforeEnter: RequireAutorization
}
